import React from 'react';
import { useNavigate } from 'react-router-dom';
import './EncuestaCard.css';

/**
 * Componente de tarjeta para mostrar encuesta en el listado
 * @param {Object} props
 * @param {number} props.id_encuesta - ID de la encuesta
 * @param {string} props.titulo - Título de la encuesta
 * @param {string} props.descripcion - Descripción de la encuesta
 * @param {string} props.imagen - URL de la imagen
 * @param {string} props.tiempo_estimado - Tiempo estimado de completado
 * @param {string} props.fecha_fin - Fecha de finalización
 * @param {boolean} props.ya_participo - Si el usuario ya participó
 */
const EncuestaCard = ({
  id_encuesta,
  titulo,
  descripcion,
  imagen,
  tiempo_estimado,
  fecha_fin,
  ya_participo = false,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/encuesta/${id_encuesta}`);
  };

  const formatFechaFin = (fecha) => {
    if (!fecha) return null;
    try {
      const date = new Date(fecha);
      return date.toLocaleDateString('es-PY', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
    } catch {
      return fecha;
    }
  };

  return (
    <div className={`encuesta-card ${ya_participo ? 'encuesta-card--participada' : ''}`}>
      {imagen && (
        <div className="encuesta-card-image">
          <img src={imagen} alt={titulo} />
        </div>
      )}
      
      <div className="encuesta-card-content">
        <h3 className="encuesta-card-title">{titulo}</h3>
        
        {descripcion && (
          <p className="encuesta-card-description">{descripcion}</p>
        )}
        
        <div className="encuesta-card-meta">
          {tiempo_estimado && (
            <span className="encuesta-card-time">
              ⏱️ {tiempo_estimado}
            </span>
          )}
          {fecha_fin && (
            <span className="encuesta-card-date">
              📅 Finaliza: {formatFechaFin(fecha_fin)}
            </span>
          )}
        </div>
        
        {ya_participo && (
          <div className="encuesta-card-badge">
            ✓ Ya participaste
          </div>
        )}
      </div>
      
      <div className="encuesta-card-actions">
        <button
          className={`encuesta-card-button ${ya_participo ? 'encuesta-card-button--disabled' : ''}`}
          onClick={handleClick}
          disabled={ya_participo}
        >
          {ya_participo ? 'Ver Encuesta' : 'Participar'}
        </button>
      </div>
    </div>
  );
};

export default EncuestaCard;

